/* ============================================================
   Health One — Healthy Cooking recipe collection
   ------------------------------------------------------------
   Drives the recipe modal on /pages/cooking (sections/ho-healthy-cooking.liquid).
   Ported from the Claude Design React export to plain JS — the theme carries no
   framework — keeping the same three views and the same CSS class names, which
   are already defined in the section's <style> block.

     tile / "Browse all 22 recipes"  ->  modal opens
     browse index                    ->  free to read, every recipe locked
     open a recipe                   ->  email gate, once per browser
     gate submitted                  ->  subscribed to a Klaviyo list, which
                                         triggers the flow that emails the PDF

   Recipe data below is from health-one-recipes.csv (2026-07-27). Macros are
   per serving unless `basis` is "per_piece" (cookies, bites, fritters, balls).
   Edit the RECIPES array directly to change a recipe.
   ============================================================ */
(function () {
  'use strict';

  var RECIPES = [
    {
      "id": "one-minute-chocolate-brownie",
      "num": "01",
      "name": "One-Minute Chocolate Brownie",
      "category": "Updated Classics",
      "sub": "Updated Classics",
      "flag": "Updated Classic",
      "hero": "Chocolate",
      "tags": [
        "glp1",
        "quick",
        "high-protein"
      ],
      "prep": "2 min",
      "cook": "1.5 min",
      "total": "3.5 min",
      "yield": "1 serving",
      "difficulty": "Easy",
      "basis": "per_serving",
      "macros": {
        "cal": 201,
        "protein": "20g",
        "carbs": "25g",
        "fat": "4g",
        "fiber": "6g"
      },
      "ingredients": [
        "1 serving Health One Chocolate",
        "1 tsp cocoa powder",
        "1 tsp vanilla extract",
        "2 Tbsp unsweetened applesauce",
        "1 Tbsp water (adjust to thick batter consistency)",
        "Cooking spray"
      ],
      "directions": [
        "Mix all dry ingredients in a microwave-safe mug or ramekin.",
        "Add applesauce, vanilla extract, and water. Stir gently until just combined — do not overmix.",
        "Spray mug lightly with cooking spray.",
        "Microwave at 70% power for 90 seconds. Check center — it should be slightly underdone.",
        "Let rest 60 seconds before eating. The brownie will firm up as it cools."
      ],
      "tips": "The applesauce replaces the moisture that whey protein absorbs. For extra richness, substitute 1 Tbsp almond butter for the applesauce.",
      "storage": "Best eaten fresh. Can be refrigerated and reheated 20 seconds in microwave."
    },
    {
      "id": "quick-peach-cobbler",
      "num": "02",
      "name": "Quick Peach Cobbler",
      "category": "Updated Classics",
      "sub": "Updated Classics",
      "flag": "Updated Classic",
      "hero": "Vanilla",
      "tags": [
        "glp1",
        "quick",
        "high-protein"
      ],
      "prep": "3 min",
      "cook": "2 min",
      "total": "5 min",
      "yield": "1 serving",
      "difficulty": "Easy",
      "basis": "per_serving",
      "macros": {
        "cal": 241,
        "protein": "22g",
        "carbs": "37g",
        "fat": "4g",
        "fiber": "6g"
      },
      "ingredients": [
        "1 serving Health One Vanilla Shake",
        "1 four-ounce container diced peaches in 100% juice (keep the juice)",
        "1/4 tsp ground cinnamon",
        "1 Tbsp Greek yogurt",
        "Cooking spray"
      ],
      "directions": [
        "Combine Health One Vanilla with the peaches AND all the juice from the container.",
        "Add Greek yogurt and cinnamon. Fold gently until just combined.",
        "Spray a microwave-safe bowl with cooking spray and pour in the mixture.",
        "Microwave at 70% power for 2 minutes. Check center — should be set but soft.",
        "Let cool 1–2 minutes. Texture firms into a cobbler-like consistency as it rests."
      ],
      "tips": "Peach juice provides essential moisture. Try with canned pears or mandarin oranges for variety.",
      "storage": "Best eaten fresh."
    },
    {
      "id": "health-one-banana-bread",
      "num": "03",
      "name": "Health One Banana Bread",
      "category": "Updated Classics",
      "sub": "Updated Classics",
      "flag": "Updated Classic",
      "hero": "Vanilla",
      "tags": [
        "meal-prep",
        "high-protein"
      ],
      "prep": "10 min",
      "cook": "18–20 min",
      "total": "30 min",
      "yield": "4 servings",
      "difficulty": "Medium",
      "basis": "per_serving",
      "macros": {
        "cal": 250,
        "protein": "23g",
        "carbs": "30g",
        "fat": "7g",
        "fiber": "6g"
      },
      "ingredients": [
        "4 servings Health One Vanilla Shake",
        "2 Tbsp oat flour",
        "1/4 tsp baking powder",
        "1/4 tsp baking soda",
        "1 Tbsp bulk sugar alternative (stevia)",
        "1 Tbsp vanilla extract",
        "1 mashed medium banana (very ripe)",
        "1 Tbsp melted coconut oil",
        "1/4 cup Greek yogurt",
        "1/2 cup water"
      ],
      "directions": [
        "Preheat oven to 300°F (reduced from 325°F for whey protein).",
        "Whisk together Health One Vanilla, oat flour, baking powder, baking soda, and sugar alternative.",
        "In a separate bowl, combine mashed banana, coconut oil, Greek yogurt, vanilla extract, and water.",
        "Pour wet ingredients into dry. Fold gently until just combined — do NOT overmix.",
        "Pour into an 8x8 baking dish lined with parchment paper and sprayed with cooking spray.",
        "Bake 18–20 minutes. Check at 18 — center should be just barely set.",
        "Remove and let cool in pan 10 minutes before cutting into 4 servings."
      ],
      "tips": "Greek yogurt is the key addition. It provides moisture, fat, and acidity that keeps the bread tender.",
      "storage": "Refrigerate up to 3 days. Reheat 30–40 seconds in microwave."
    },
    {
      "id": "chocolate-mousse",
      "num": "04",
      "name": "Chocolate Mousse",
      "category": "Updated Classics",
      "sub": "Updated Classics",
      "flag": "Updated Classic",
      "hero": "Chocolate",
      "tags": [
        "glp1",
        "high-protein"
      ],
      "prep": "5 min",
      "cook": "Chill 15 min",
      "total": "20 min",
      "yield": "2 servings",
      "difficulty": "Easy",
      "basis": "per_serving",
      "macros": {
        "cal": 186,
        "protein": "20g",
        "carbs": "24g",
        "fat": "4g",
        "fiber": "6g"
      },
      "ingredients": [
        "2 servings Health One Chocolate Shake",
        "1/2 tsp cocoa powder",
        "1/8 tsp cinnamon",
        "1 Tbsp bulk sugar alternative (stevia or monk fruit)",
        "4 oz cold water",
        "1/2 cup sliced fresh strawberries"
      ],
      "directions": [
        "Mix all dry ingredients in a bowl.",
        "Add cold water gradually, stirring until smooth and thick. Add water 1 Tbsp at a time if too thick.",
        "Divide into two serving dishes.",
        "Refrigerate 15–20 minutes until set.",
        "Top with fresh strawberries and enjoy."
      ],
      "tips": "For extra-creamy version, replace 2 oz water with coconut cream.",
      "storage": "Refrigerate up to 2 days covered."
    },
    {
      "id": "rich-chocolate-protein-cookies",
      "num": "05",
      "name": "Rich Chocolate Protein Cookies",
      "category": "Updated Classics",
      "sub": "Updated Classics",
      "flag": "Updated Classic",
      "hero": "Chocolate",
      "tags": [
        "meal-prep"
      ],
      "prep": "5 min",
      "cook": "10 min",
      "total": "15 min",
      "yield": "6 cookies",
      "difficulty": "Medium",
      "basis": "per_piece",
      "macros": {
        "cal": 53,
        "protein": "4g",
        "carbs": "4g",
        "fat": "3g",
        "fiber": "1g"
      },
      "ingredients": [
        "1 serving Health One Chocolate Shake",
        "1 Tbsp unsweetened cocoa powder",
        "1 tsp baking powder",
        "1 tsp bulk sugar alternative",
        "1/4 tsp almond extract (or coconut or mint)",
        "2 Tbsp unsweetened applesauce",
        "1 Tbsp melted coconut oil",
        "1 Tbsp water (adjust as needed)"
      ],
      "directions": [
        "Preheat oven to 325°F.",
        "Mix Health One Chocolate, cocoa powder, baking powder, and sugar alternative.",
        "Add applesauce, coconut oil, extract, and water. Stir gently until just combined.",
        "Drop dough by rounded tablespoons onto parchment-lined baking sheet. Flatten slightly.",
        "Bake 8–10 minutes. Cookies should look slightly underdone in center.",
        "Let cool on baking sheet 5 minutes — they firm up significantly as they cool."
      ],
      "tips": "Mint extract makes these taste like thin mints. Makes about 6 small cookies.",
      "storage": "Store in airtight container at room temperature up to 3 days, or refrigerate up to 5 days."
    },
    {
      "id": "chocolate-chia-pudding",
      "num": "06",
      "name": "Chocolate Chia Pudding",
      "category": "Updated Classics",
      "sub": "Updated Classics",
      "flag": "Updated Classic",
      "hero": "Chocolate",
      "tags": [
        "glp1",
        "meal-prep",
        "high-protein"
      ],
      "prep": "5 min",
      "cook": "Chill overnight",
      "total": "Overnight",
      "yield": "2 servings",
      "difficulty": "Easy",
      "basis": "per_serving",
      "macros": {
        "cal": 390,
        "protein": "27g",
        "carbs": "38g",
        "fat": "20g",
        "fiber": "19g"
      },
      "ingredients": [
        "2 servings Health One Chocolate Shake",
        "6 Tbsp chia seeds",
        "2 tsp dark cocoa powder",
        "1 Tbsp brown sugar alternative",
        "1 tsp vanilla extract",
        "2 cups almond milk"
      ],
      "directions": [
        "Combine Health One Chocolate, chia seeds, cocoa powder, and sugar alternative.",
        "Add vanilla extract and half the almond milk. Stir well.",
        "Add remaining almond milk and stir until smooth.",
        "Cover and refrigerate overnight (at least 6 hours).",
        "Stir before serving. Add a splash more almond milk if too thick."
      ],
      "tips": "Excellent meal prep option — make Sunday for Monday/Tuesday. High fiber content supports digestive health.",
      "storage": "Refrigerate up to 3 days. Stir before serving."
    },
    {
      "id": "pineapple-upside-down-cake",
      "num": "07",
      "name": "Pineapple Upside-Down Cake",
      "category": "Updated Classics",
      "sub": "Updated Classics",
      "flag": "Updated Classic",
      "hero": "Vanilla",
      "tags": [
        "meal-prep",
        "high-protein"
      ],
      "prep": "10 min",
      "cook": "18 min",
      "total": "28 min",
      "yield": "4 servings",
      "difficulty": "Medium",
      "basis": "per_serving",
      "macros": {
        "cal": 218,
        "protein": "23g",
        "carbs": "30g",
        "fat": "4g",
        "fiber": "6g"
      },
      "ingredients": [
        "4 servings Health One Vanilla Shake",
        "1/4 cup oat flour",
        "1–2 Tbsp bulk sugar alternative",
        "1/2 tsp baking soda",
        "1/2 tsp baking powder",
        "1/2 cup crushed pineapple in its own juice (keep ALL juice)",
        "1/4 cup Greek yogurt",
        "3/4 cup water"
      ],
      "directions": [
        "Preheat oven to 300°F.",
        "Whisk together dry ingredients.",
        "Add pineapple with juice, Greek yogurt, and water. Fold gently.",
        "Line 8-inch square pan with parchment paper, spray with cooking spray.",
        "Pour batter in, spread evenly.",
        "Bake 16–18 minutes. Check at 16 — slight jiggle is fine.",
        "Cool in pan 10 minutes, then cut into 4 servings."
      ],
      "tips": "Reduced leavening — whey naturally creates more lift than soy.",
      "storage": "Refrigerate up to 3 days. Reheat 30–40 seconds in microwave."
    },
    {
      "id": "criss-cross-peanut-butter-cookies",
      "num": "08",
      "name": "Criss-Cross Peanut Butter Cookies",
      "category": "Updated Classics",
      "sub": "Updated Classics",
      "flag": "Updated Classic",
      "hero": "Vanilla",
      "tags": [
        "meal-prep"
      ],
      "prep": "5 min",
      "cook": "10 min",
      "total": "15 min",
      "yield": "8 cookies",
      "difficulty": "Medium",
      "basis": "per_piece",
      "macros": {
        "cal": 70,
        "protein": "6g",
        "carbs": "7g",
        "fat": "3g",
        "fiber": "2g"
      },
      "ingredients": [
        "2 servings Health One Vanilla Shake",
        "2 Tbsp PB2 peanut butter powder",
        "2 Tbsp oat flour",
        "1/2 tsp baking powder",
        "1 tsp vanilla extract",
        "1/4 cup water plus 2 Tbsp",
        "1 Tbsp melted coconut oil"
      ],
      "directions": [
        "Preheat oven to 325°F.",
        "Mix dry ingredients in a bowl.",
        "Add vanilla, water, and coconut oil. Stir until just combined.",
        "Drop by teaspoon onto parchment-lined sheet.",
        "Press criss-cross pattern with a fork dipped in water.",
        "Bake 8–10 minutes. They’ll look soft — they firm as they cool.",
        "Cool on sheet 5 minutes before transferring."
      ],
      "tips": "For richer version, use 1 Tbsp real peanut butter instead of PB2.",
      "storage": "Store airtight at room temperature up to 3 days, or refrigerate up to 5 days."
    },
    {
      "id": "vanilla-protein-overnight-oats",
      "num": "09",
      "name": "Vanilla Protein Overnight Oats",
      "category": "Breakfast",
      "sub": "Breakfast",
      "flag": "New",
      "hero": "Vanilla",
      "tags": [
        "meal-prep",
        "high-protein"
      ],
      "prep": "5 min",
      "cook": "Chill overnight",
      "total": "Overnight",
      "yield": "1 serving",
      "difficulty": "Easy",
      "basis": "per_serving",
      "macros": {
        "cal": 528,
        "protein": "34g",
        "carbs": "78g",
        "fat": "15g",
        "fiber": "16g"
      },
      "ingredients": [
        "1 serving Health One Vanilla Shake",
        "1/2 cup rolled oats",
        "3/4 cup milk of choice",
        "1 Tbsp chia seeds",
        "1/2 banana, sliced (topping)",
        "Handful of berries (topping)"
      ],
      "directions": [
        "Combine Health One Vanilla, oats, and chia seeds in a jar.",
        "Pour in milk and stir well.",
        "Cover and refrigerate overnight (at least 6 hours).",
        "Stir in morning; add splash more milk if too thick.",
        "Top with banana and berries."
      ],
      "tips": "Ideal meal prep — make 3 jars Sunday for the week. For chocolate version, use Chocolate Shake and top with almonds.",
      "storage": "Refrigerate up to 3 days. Add toppings fresh each morning."
    },
    {
      "id": "loaded-protein-potato-soup-bowl",
      "num": "10",
      "name": "Loaded Protein Potato Soup Bowl",
      "category": "Savory Meals",
      "sub": "Savory Meals",
      "flag": "New",
      "hero": "Potato",
      "tags": [
        "glp1",
        "quick",
        "nausea",
        "high-protein"
      ],
      "prep": "3 min",
      "cook": "5 min",
      "total": "8 min",
      "yield": "1 serving",
      "difficulty": "Easy",
      "basis": "per_serving",
      "macros": {
        "cal": 216,
        "protein": "21g",
        "carbs": "27g",
        "fat": "4g",
        "fiber": "4g"
      },
      "ingredients": [
        "1 serving Health One Potato",
        "1 cup hot water",
        "2 Tbsp plain Greek yogurt",
        "1 Tbsp shredded cheddar cheese",
        "1 Tbsp chopped chives or green onion",
        "Pinch of smoked paprika",
        "Salt and pepper to taste"
      ],
      "directions": [
        "Prepare Health One Potato with hot water per package directions.",
        "Stir in Greek yogurt until smooth and creamy.",
        "Pour into bowl, top with cheddar, chives, and paprika.",
        "Season to taste."
      ],
      "tips": "Excellent for nausea days — warm, savory, easy to keep down. For heartier version, add 1 oz diced cooked chicken.",
      "storage": "Best eaten fresh. Leftovers can be refrigerated and reheated."
    },
    {
      "id": "chocolate-peanut-butter-power-smoothie",
      "num": "11",
      "name": "Chocolate Peanut Butter Power Smoothie",
      "category": "Smoothies",
      "sub": "Smoothies",
      "flag": "New",
      "hero": "Chocolate",
      "tags": [
        "quick",
        "high-protein"
      ],
      "prep": "5 min",
      "cook": "None",
      "total": "5 min",
      "yield": "1 serving",
      "difficulty": "Easy",
      "basis": "per_serving",
      "macros": {
        "cal": 441,
        "protein": "32g",
        "carbs": "49g",
        "fat": "16g",
        "fiber": "8g"
      },
      "ingredients": [
        "1 serving Health One Chocolate Shake",
        "1 Tbsp natural peanut butter",
        "1/2 frozen banana",
        "1 cup milk of choice",
        "1/2 cup ice",
        "Optional: 1 tsp cocoa powder"
      ],
      "directions": [
        "Add milk, frozen banana, and peanut butter to blender.",
        "Add Health One Chocolate and ice.",
        "Blend on high 30–45 seconds until smooth.",
        "Pour and enjoy immediately."
      ],
      "tips": "Great post-workout recovery shake. Frozen banana creates thick milkshake texture.",
      "storage": "Best enjoyed immediately. Can be refrigerated 1 hour max."
    },
    {
      "id": "savory-protein-potato-fritters",
      "num": "12",
      "name": "Savory Protein Potato Fritters",
      "category": "Savory Meals",
      "sub": "Savory Meals",
      "flag": "New",
      "hero": "Potato",
      "tags": [
        "meal-prep"
      ],
      "prep": "5 min",
      "cook": "6 min",
      "total": "11 min",
      "yield": "4 fritters",
      "difficulty": "Easy",
      "basis": "per_piece",
      "macros": {
        "cal": 76,
        "protein": "6g",
        "carbs": "9g",
        "fat": "2g",
        "fiber": "1g"
      },
      "ingredients": [
        "1 serving Health One Potato (dry, do not add water)",
        "1 egg, beaten",
        "2 Tbsp oat flour",
        "1 Tbsp finely diced onion",
        "1 Tbsp chopped fresh parsley",
        "Salt and pepper to taste",
        "1 tsp olive oil or cooking spray"
      ],
      "directions": [
        "Combine dry Health One Potato, beaten egg, oat flour, onion, parsley, salt, and pepper. If too dry, add water 1 tsp at a time.",
        "Heat non-stick skillet over medium heat with olive oil.",
        "Drop batter by heaping tablespoons (makes 4). Flatten slightly.",
        "Cook 3 minutes per side until golden brown.",
        "Serve with a dollop of Greek yogurt or light sour cream."
      ],
      "tips": "Creative savory option showcasing Health One Potato’s versatility. The egg provides binding that works perfectly with whey protein.",
      "storage": "Refrigerate up to 2 days. Reheat in skillet for best texture."
    },
    {
      "id": "fluffy-vanilla-protein-pancakes",
      "num": "13",
      "name": "Fluffy Vanilla Protein Pancakes",
      "category": "Breakfast",
      "sub": "Breakfast",
      "flag": "New",
      "hero": "Pancake",
      "tags": [],
      "prep": "5 min",
      "cook": "8 min",
      "total": "13 min",
      "yield": "4 pancakes",
      "difficulty": "Easy",
      "basis": "per_piece",
      "macros": {
        "cal": 76,
        "protein": "6g",
        "carbs": "6g",
        "fat": "2g",
        "fiber": "1g"
      },
      "ingredients": [
        "1 serving Health One Pancake & Baking Mix",
        "1 egg",
        "1/3 cup milk of choice",
        "1 tsp vanilla extract",
        "1/2 tsp cinnamon (optional)",
        "Cooking spray or butter for griddle",
        "Fresh berries for topping"
      ],
      "directions": [
        "Combine Pancake Mix, egg, milk, vanilla, and cinnamon.",
        "Stir gently until just combined — a few lumps are fine.",
        "Let batter rest 2 minutes while griddle heats to medium-low.",
        "Spray griddle, pour batter in 3-inch circles (makes 4).",
        "Cook until bubbles form, about 2–3 minutes. Flip, cook 1–2 more.",
        "Serve with fresh berries."
      ],
      "tips": "Key is medium-low heat — higher heat browns outside while inside stays raw. Let batter rest for fluffier results.",
      "storage": "Best eaten fresh. Leftover pancakes can be frozen and reheated in toaster."
    },
    {
      "id": "green-power-smoothie",
      "num": "14",
      "name": "Green Power Smoothie",
      "category": "Smoothies",
      "sub": "Smoothies",
      "flag": "New",
      "hero": "Vanilla",
      "tags": [
        "glp1",
        "quick",
        "high-protein"
      ],
      "prep": "5 min",
      "cook": "None",
      "total": "5 min",
      "yield": "1 serving",
      "difficulty": "Easy",
      "basis": "per_serving",
      "macros": {
        "cal": 307,
        "protein": "23g",
        "carbs": "49g",
        "fat": "7g",
        "fiber": "10g"
      },
      "ingredients": [
        "1 serving Health One Vanilla Shake",
        "1 cup unsweetened almond milk",
        "1 large handful baby spinach (~1 cup packed)",
        "1/2 frozen banana",
        "1/2 cup frozen mango chunks",
        "1/2 cup ice"
      ],
      "directions": [
        "Add almond milk and spinach to blender first. Blend briefly.",
        "Add Health One Vanilla, banana, mango, and ice.",
        "Blend on high 45–60 seconds until smooth.",
        "Pour and enjoy immediately."
      ],
      "tips": "Blend spinach with liquid first to prevent green chunks. Mango and banana mask spinach flavor completely.",
      "storage": "Best enjoyed immediately."
    },
    {
      "id": "chocolate-protein-mug-cake",
      "num": "15",
      "name": "Chocolate Protein Mug Cake",
      "category": "Quick Meals & Snacks",
      "sub": "Quick Meals & Snacks",
      "flag": "New",
      "hero": "Chocolate",
      "tags": [
        "glp1",
        "quick",
        "high-protein"
      ],
      "prep": "3 min",
      "cook": "1.5 min",
      "total": "5 min",
      "yield": "1 serving",
      "difficulty": "Easy",
      "basis": "per_serving",
      "macros": {
        "cal": 230,
        "protein": "25g",
        "carbs": "29g",
        "fat": "4g",
        "fiber": "6g"
      },
      "ingredients": [
        "1 serving Health One Chocolate Shake",
        "1 Tbsp oat flour",
        "1/2 tsp baking powder",
        "1 egg white",
        "2 Tbsp unsweetened applesauce",
        "1 Tbsp water",
        "Optional: 1 Tbsp dark chocolate chips"
      ],
      "directions": [
        "Mix Health One Chocolate, oat flour, and baking powder in a large mug.",
        "Add egg white, applesauce, and water. Stir gently.",
        "If using chocolate chips, fold in gently.",
        "Microwave at 70% power for 80–90 seconds. Center should look slightly underdone.",
        "Let rest 60 seconds — cake continues setting as it cools.",
        "Eat directly from the mug."
      ],
      "tips": "Egg white provides structure and lift. Don’t skip the rest time — essential for proper texture.",
      "storage": "Best eaten fresh."
    },
    {
      "id": "protein-packed-stuffed-peppers",
      "num": "16",
      "name": "Protein-Packed Stuffed Peppers",
      "category": "Savory Meals",
      "sub": "Savory Meals",
      "flag": "New",
      "hero": "Potato",
      "tags": [
        "meal-prep",
        "high-protein"
      ],
      "prep": "10 min",
      "cook": "20 min",
      "total": "30 min",
      "yield": "2 servings",
      "difficulty": "Medium",
      "basis": "per_serving",
      "macros": {
        "cal": 217,
        "protein": "21g",
        "carbs": "17g",
        "fat": "9g",
        "fiber": "3g"
      },
      "ingredients": [
        "1 bell pepper, halved and seeded",
        "1 serving Health One Potato (prepared with 3/4 cup hot water)",
        "3 oz cooked ground turkey or chicken",
        "2 Tbsp shredded cheddar cheese",
        "1 Tbsp diced onion",
        "Salt, pepper, and garlic powder to taste"
      ],
      "directions": [
        "Preheat oven to 375°F. Place pepper halves cut-side up in a baking dish.",
        "Prepare Health One Potato with 3/4 cup hot water (slightly thicker than normal).",
        "Mix soup with cooked meat, onion, and seasonings.",
        "Spoon filling into pepper halves. Top with cheese.",
        "Cover with foil and bake for 18–20 minutes.",
        "Remove foil for final 2 minutes to brown cheese."
      ],
      "tips": "Health One Potato acts as a creamy binding sauce and protein boost. Family-friendly — double recipe for dinner for 4.",
      "storage": "Refrigerate for up to 3 days. Reheat covered at 350°F for 10–15 minutes or microwave 2 minutes."
    },
    {
      "id": "vanilla-protein-energy-bites",
      "num": "17",
      "name": "Vanilla Protein Energy Bites",
      "category": "Quick Meals & Snacks",
      "sub": "Quick Meals & Snacks",
      "flag": "New",
      "hero": "Vanilla",
      "tags": [
        "meal-prep"
      ],
      "prep": "10 min",
      "cook": "Chill 30 min",
      "total": "40 min",
      "yield": "10 bites",
      "difficulty": "Easy",
      "basis": "per_piece",
      "macros": {
        "cal": 119,
        "protein": "6g",
        "carbs": "14g",
        "fat": "6g",
        "fiber": "3g"
      },
      "ingredients": [
        "2 servings Health One Vanilla Shake",
        "1/2 cup rolled oats",
        "1/4 cup natural peanut or almond butter",
        "2 Tbsp honey or sugar-free maple syrup",
        "2 Tbsp mini dark chocolate chips",
        "1 Tbsp chia seeds",
        "2–3 Tbsp milk of choice"
      ],
      "directions": [
        "Combine Health One Vanilla, oats, chia seeds, and chocolate chips.",
        "Add nut butter and honey. Stir until a thick, sticky dough forms.",
        "Add milk 1 Tbsp at a time until dough holds together when pressed.",
        "Roll into 10 balls (about 1 Tbsp each).",
        "Refrigerate at least 30 minutes until firm."
      ],
      "tips": "No baking required. For the tropical version, swap chocolate chips for coconut flakes.",
      "storage": "Refrigerate in an airtight container for up to 5 days. Can be frozen for up to 1 month."
    },
    {
      "id": "creamy-potato-and-broccoli-protein-casserole",
      "num": "18",
      "name": "Creamy Potato & Broccoli Protein Casserole",
      "category": "Savory Meals",
      "sub": "Savory Meals",
      "flag": "New",
      "hero": "Potato",
      "tags": [
        "meal-prep",
        "high-protein"
      ],
      "prep": "10 min",
      "cook": "25 min",
      "total": "35 min",
      "yield": "4 servings",
      "difficulty": "Medium",
      "basis": "per_serving",
      "macros": {
        "cal": 196,
        "protein": "22g",
        "carbs": "18g",
        "fat": "4g",
        "fiber": "3g"
      },
      "ingredients": [
        "2 servings Health One Potato",
        "1.5 cups hot water",
        "2 cups broccoli florets (fresh or frozen)",
        "1 cup cooked diced chicken breast",
        "1/4 cup shredded cheddar cheese",
        "2 Tbsp Greek yogurt",
        "1/2 tsp garlic powder",
        "Salt and pepper to taste",
        "2 Tbsp panko breadcrumbs (optional)"
      ],
      "directions": [
        "Preheat oven to 350°F.",
        "Prepare Health One Potato with 1.5 cups hot water. Stir in Greek yogurt and garlic powder.",
        "Steam broccoli until just tender (3 min). If frozen, thaw and drain.",
        "Layer broccoli and chicken in a baking dish.",
        "Pour potato soup mixture over top. Stir gently.",
        "Top with cheese and optional panko.",
        "Bake 20–25 minutes until bubbling and golden.",
        "Let rest 5 minutes. Divide into 4 portions."
      ],
      "tips": "Comfort food that delivers complete nutrition. Swap broccoli for cauliflower or mixed veggies.",
      "storage": "Refrigerate up to 3 days. Reheat covered at 350°F for 15 minutes or microwave 2–3 minutes."
    },
    {
      "id": "savory-protein-egg-bites",
      "num": "19",
      "name": "Savory Protein Egg Bites",
      "category": "Breakfast",
      "sub": "Breakfast",
      "flag": "New",
      "hero": "Potato",
      "tags": [
        "glp1",
        "meal-prep"
      ],
      "prep": "10 min",
      "cook": "20 min",
      "total": "30 min",
      "yield": "6 bites",
      "difficulty": "Easy",
      "basis": "per_piece",
      "macros": {
        "cal": 93,
        "protein": "8g",
        "carbs": "5g",
        "fat": "4g",
        "fiber": "1g"
      },
      "ingredients": [
        "1 serving Health One Potato (dry, do not add water)",
        "4 large eggs",
        "1/4 cup cottage cheese",
        "2 Tbsp shredded cheddar cheese",
        "1 Tbsp diced bell pepper",
        "1 Tbsp diced spinach (fresh or thawed frozen)",
        "1/4 tsp garlic powder",
        "Salt and pepper to taste",
        "Cooking spray"
      ],
      "directions": [
        "Preheat oven to 350°F. Spray a 6-cup silicone or non-stick muffin tin with cooking spray.",
        "Whisk eggs in a large bowl until smooth.",
        "Add dry Health One Potato powder and whisk until fully incorporated (no lumps).",
        "Stir in cottage cheese, cheddar, bell pepper, spinach, garlic powder, salt, and pepper.",
        "Divide mixture evenly into 6 muffin cups.",
        "Bake 18–20 minutes until centers are set and edges are lightly golden.",
        "Let cool 5 minutes before removing from tin."
      ],
      "tips": "Perfect grab-and-go breakfast for GLP-1 patients who struggle with morning appetite. Two bites provide ~16g protein. Customize with different vegetables — mushrooms, onions, and tomatoes all work.",
      "storage": "Refrigerate up to 5 days. Microwave 20–30 seconds to reheat. Freeze up to 2 months."
    },
    {
      "id": "vanilla-cinnamon-power-balls-nut-free",
      "num": "20",
      "name": "Vanilla Cinnamon Power Balls (Nut-Free)",
      "category": "Quick Meals & Snacks",
      "sub": "Quick Meals & Snacks",
      "flag": "New",
      "hero": "Vanilla",
      "tags": [
        "meal-prep"
      ],
      "prep": "10 min",
      "cook": "Chill 20 min",
      "total": "30 min",
      "yield": "12 balls",
      "difficulty": "Easy",
      "basis": "per_piece",
      "macros": {
        "cal": 92,
        "protein": "5g",
        "carbs": "10g",
        "fat": "5g",
        "fiber": "2g"
      },
      "ingredients": [
        "2 servings Health One Vanilla Shake",
        "1/2 cup rolled oats",
        "1/4 cup sunflower seed butter (nut-free)",
        "2 Tbsp honey or sugar-free maple syrup",
        "1 tsp cinnamon",
        "1/2 tsp vanilla extract",
        "1 Tbsp ground flax seeds",
        "2–3 Tbsp milk of choice (adjust as needed)",
        "Optional coating: 2 Tbsp finely shredded unsweetened coconut"
      ],
      "directions": [
        "In a large bowl, combine Health One Vanilla, oats, flax seeds, and cinnamon.",
        "Add sunflower seed butter, honey, and vanilla extract. Mix until a thick dough forms.",
        "Add milk 1 Tbsp at a time until dough holds together when pressed.",
        "Roll dough into 12 small balls (about 2 tsp each).",
        "Optional: roll each ball in shredded coconut for extra texture.",
        "Refrigerate at least 20 minutes until firm."
      ],
      "tips": "Allergy-friendly alternative to the Vanilla Protein Energy Bites — perfect for school lunches or shared work environments. The cinnamon adds warmth and helps stabilize blood sugar. Two balls + Greek yogurt = balanced snack.",
      "storage": "Refrigerate in an airtight container for up to 7 days. Freeze up to 2 months."
    },
    {
      "id": "gentle-banana-protein-pudding",
      "num": "21",
      "name": "Gentle Banana Protein Pudding",
      "category": "Quick Meals & Snacks",
      "sub": "Quick Meals & Snacks",
      "flag": "New",
      "hero": "Vanilla",
      "tags": [
        "glp1",
        "quick",
        "nausea",
        "high-protein"
      ],
      "prep": "5 min",
      "cook": "None",
      "total": "5 min",
      "yield": "1 serving",
      "difficulty": "Easy",
      "basis": "per_serving",
      "macros": {
        "cal": 281,
        "protein": "22g",
        "carbs": "48g",
        "fat": "5g",
        "fiber": "9g"
      },
      "ingredients": [
        "1 serving Health One Vanilla Shake",
        "1 medium ripe banana",
        "1/3 cup unsweetened almond milk (cold)",
        "1/4 tsp ground ginger (optional, helps with nausea)",
        "Pinch of cinnamon"
      ],
      "directions": [
        "Mash banana thoroughly in a bowl until smooth (no large chunks).",
        "Add Health One Vanilla, cold almond milk, ginger (if using), and cinnamon.",
        "Stir gently until smooth and pudding-like consistency forms.",
        "Eat immediately, or refrigerate 5–10 minutes for a thicker texture."
      ],
      "tips": "Designed specifically for nausea days when nothing sounds good. Banana is one of the BRAT diet staples (bland, easy to digest). Ginger has clinical evidence for reducing nausea. Cold temperature helps when warm food is unappealing. If even cold is too much, let it sit at room temperature for 10 minutes before eating.",
      "storage": "Best eaten fresh. Banana will brown if stored."
    },
    {
      "id": "lemon-blueberry-protein-pancakes",
      "num": "22",
      "name": "Lemon Blueberry Protein Pancakes",
      "category": "Breakfast",
      "sub": "Breakfast",
      "flag": "New",
      "hero": "Pancake",
      "tags": [
        "meal-prep",
        "high-protein"
      ],
      "prep": "5 min",
      "cook": "8 min",
      "total": "13 min",
      "yield": "1 serving",
      "difficulty": "Easy",
      "basis": "per_serving",
      "macros": {
        "cal": 225,
        "protein": "20g",
        "carbs": "28g",
        "fat": "3g",
        "fiber": "5g"
      },
      "ingredients": [
        "1 serving Health One Pancake & Baking Mix",
        "1 large egg white",
        "2 Tbsp fresh lemon juice",
        "1 tsp lemon zest",
        "2 Tbsp water",
        "1/4 cup fresh blueberries",
        "Cooking spray or butter for griddle"
      ],
      "directions": [
        "Whisk Pancake & Baking Mix, egg white, lemon juice, zest, and water until a smooth batter forms.",
        "Gently fold in blueberries — do not overmix.",
        "Let batter rest 2 minutes while a non-stick griddle heats to medium-low.",
        "Spray the griddle and pour batter into 3-inch circles (makes about 4).",
        "Cook 2–3 minutes until bubbles form, then flip and cook 1–2 minutes until golden.",
        "Serve warm, topped with extra blueberries or a little lemon zest."
      ],
      "tips": "Bright lemon makes this appealing when appetite is low. Keep heat medium-low so the centers cook through. Frozen blueberries work well — fold them in straight from the freezer.",
      "storage": "Best eaten fresh. Leftover pancakes freeze well; reheat in a toaster or skillet."
    }
  ];

  /* ---------- lookups ---------- */

  var TAGS = [
    { key: 'glp1',         label: 'GLP-1 Friendly', legend: 'Specifically suited for GLP-1 nutrition support: gentle, high-protein, low-volume.' },
    { key: 'quick',        label: 'Quick',          legend: 'Ready in under 10 minutes, start to finish.' },
    { key: 'meal-prep',    label: 'Meal Prep',      legend: 'Make ahead and store — perfect for batch cooking.' },
    { key: 'nausea',       label: 'Nausea-Day',     legend: 'Gentle on a sensitive stomach when nothing sounds good.' },
    { key: 'high-protein', label: 'High Protein',   legend: '20g+ of protein per serving.' }
  ];
  var TAG_LABEL = {};
  TAGS.forEach(function (t) { TAG_LABEL[t.key] = t.label; });

  var CATEGORY_ORDER = ['Updated Classics', 'Breakfast', 'Smoothies', 'Savory Meals', 'Quick Meals & Snacks'];

  var BY_ID = {};
  RECIPES.forEach(function (r) { BY_ID[r.id] = r; });

  var UNLOCK_KEY = 'ho_recipes_unlocked';
  var EMAIL_KEY = 'ho_recipes_email';
  var UNLOCK_EVENT = 'ho:recipes-unlocked';
  var KLAVIYO_REVISION = '2026-07-15';

  /* ---------- config, read off the recipes section ---------- */

  var host = document.querySelector('[data-ho-recipes]');
  if (!host) return;
  var KLAVIYO_KEY = (host.getAttribute('data-klaviyo-key') || '').trim();
  var KLAVIYO_LIST = (host.getAttribute('data-klaviyo-list') || '').trim();

  /* ---------- helpers ---------- */

  var ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function esc(value) {
    return String(value).replace(/[&<>"']/g, function (c) { return ESCAPES[c]; });
  }

  function icon(path, extraClass) {
    return '<svg' + (extraClass ? ' class="' + extraClass + '"' : '') + ' viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + path + '</svg>';
  }
  var ARROW_RIGHT = '<path d="M5 12h14M13 5l7 7-7 7"/>';
  var ARROW_LEFT = '<path d="M15 18l-6-6 6-6"/>';
  var CHEVRON = '<path d="M9 18l6-6-6-6"/>';
  var PADLOCK = '<rect x="4" y="11" width="16" height="10" rx="1"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>';

  function flagBadge(recipe) {
    var kind = recipe.flag === 'New' ? 'new' : 'classic';
    return '<span class="recipe-flag recipe-flag--' + kind + '">' + esc(recipe.flag) + '</span>';
  }

  function tagBadges(recipe, small) {
    return recipe.tags.map(function (t) {
      return '<span class="recipe-tag' + (small ? ' recipe-tag--sm' : '') + ' recipe-tag--' + t + '">' + esc(TAG_LABEL[t]) + '</span>';
    }).join('');
  }

  /* "6 cookies" -> "Nutrition per cookie". Everything else is per serving. */
  function basisLabel(recipe) {
    if (recipe.basis !== 'per_piece') return 'Nutrition per serving';
    var noun = (recipe.yield.split(' ')[1] || 'piece').replace(/s$/, '');
    return 'Nutrition per ' + noun;
  }

  function macroLine(recipe) {
    var m = recipe.macros;
    var items = [['Cal', m.cal], ['Protein', m.protein], ['Carbs', m.carbs], ['Fat', m.fat], ['Fiber', m.fiber]];
    return '<div class="macro-line">' + items.map(function (pair) {
      return '<div class="macro-line__item">' +
        '<span class="macro-line__value">' + esc(pair[1]) + '</span>' +
        '<span class="macro-line__label">' + esc(pair[0]) + '</span>' +
        '</div>';
    }).join('') + '</div>' +
      '<p class="macro-line__basis">' + esc(basisLabel(recipe)) + '</p>';
  }

  function metaRow(recipe) {
    var cells = [['Prep', recipe.prep], ['Cook', recipe.cook], ['Total', recipe.total],
                 ['Yield', recipe.yield], ['Difficulty', recipe.difficulty]];
    return '<dl class="recipe-view__meta">' + cells.map(function (pair) {
      return '<div><dt>' + esc(pair[0]) + '</dt><dd>' + esc(pair[1]) + '</dd></div>';
    }).join('') + '</dl>';
  }

  function backButton() {
    return '<button type="button" class="recipe-view__back" data-ho-browse>' +
      icon(ARROW_LEFT) + 'All ' + RECIPES.length + ' recipes</button>';
  }

  /* ---------- unlock state ---------- */

  function isUnlocked() {
    try { return localStorage.getItem(UNLOCK_KEY) === '1'; } catch (e) { return false; }
  }

  function rememberUnlock(email) {
    try {
      localStorage.setItem(UNLOCK_KEY, '1');
      if (email) localStorage.setItem(EMAIL_KEY, email);
    } catch (e) { /* private browsing — unlocked for this page view only */ }
    try { window.dispatchEvent(new CustomEvent(UNLOCK_EVENT, { detail: { email: email } })); } catch (e) {}
    if (email && window.klaviyo && typeof window.klaviyo.identify === 'function') {
      try { window.klaviyo.identify({ $email: email }); } catch (e) {}
    }
  }

  /* Subscribes the address to the Klaviyo list whose "added to list" flow sends
     the printable PDF. Client-side endpoint, public key only. */
  function subscribe(email, source) {
    if (!KLAVIYO_KEY || !KLAVIYO_LIST) return Promise.reject(new Error('not-configured'));
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_KEY), {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source || 'Healthy Cooking — recipe gate',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } }
        }
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo responded ' + res.status);
    });
  }

  /* ---------- views ---------- */

  function recipeView(recipe, hasBrowse) {
    return '<div class="recipe-view">' +
      '<header class="recipe-view__head">' +
        (hasBrowse ? backButton() : '') +
        '<p class="recipe-view__category">' + flagBadge(recipe) + ' ' + esc(recipe.sub) + '</p>' +
        '<h2 id="ho-recipe-modal-title" class="recipe-view__title">' + esc(recipe.name) + '</h2>' +
        (recipe.tags.length ? '<div class="recipe-view__tags">' + tagBadges(recipe) + '</div>' : '') +
        '<a class="recipe-view__hero-link" href="#products" data-ho-shop>' +
          '<span class="recipe-view__hero-dot"></span>Made with Health One ' + esc(recipe.hero) + icon(ARROW_RIGHT) +
        '</a>' +
        metaRow(recipe) +
        macroLine(recipe) +
      '</header>' +
      '<div class="recipe-view__body">' +
        '<section class="recipe-view__col">' +
          '<h3 class="recipe-view__h3">Ingredients</h3>' +
          '<ul class="recipe-view__ingredients">' + recipe.ingredients.map(function (ing) {
            return '<li><span class="recipe-view__check"></span>' + esc(ing) + '</li>';
          }).join('') + '</ul>' +
        '</section>' +
        '<section class="recipe-view__col">' +
          '<h3 class="recipe-view__h3">Directions</h3>' +
          '<ol class="recipe-view__directions">' + recipe.directions.map(function (step, i) {
            var n = String(i + 1);
            return '<li><span class="recipe-view__step-num">' + (n.length < 2 ? '0' + n : n) + '</span><span>' + esc(step) + '</span></li>';
          }).join('') + '</ol>' +
        '</section>' +
      '</div>' +
      ((recipe.tips || recipe.storage) ?
        '<footer class="recipe-view__foot">' +
          (recipe.tips ? '<p><strong>Tips.</strong> ' + esc(recipe.tips) + '</p>' : '') +
          (recipe.storage ? '<p><strong>Storage.</strong> ' + esc(recipe.storage) + '</p>' : '') +
        '</footer>' : '') +
    '</div>';
  }

  function browseView(activeTag, unlocked) {
    var shown = activeTag ? RECIPES.filter(function (r) { return r.tags.indexOf(activeTag) > -1; }) : RECIPES;

    var chips = '<button type="button" class="recipe-filter-chip' + (activeTag ? '' : ' is-active') + '" data-ho-filter="">' +
      'All<span class="recipe-filter-chip__count">' + RECIPES.length + '</span></button>' +
      TAGS.map(function (t) {
        var count = RECIPES.filter(function (r) { return r.tags.indexOf(t.key) > -1; }).length;
        return '<button type="button" class="recipe-filter-chip recipe-filter-chip--' + t.key +
          (activeTag === t.key ? ' is-active' : '') + '" data-ho-filter="' + t.key + '" title="' + esc(t.legend) + '">' +
          esc(t.label) + '<span class="recipe-filter-chip__count">' + count + '</span></button>';
      }).join('');

    var body = CATEGORY_ORDER.filter(function (cat) {
      return shown.some(function (r) { return r.category === cat; });
    }).map(function (cat) {
      var items = shown.filter(function (r) { return r.category === cat; }).map(function (r) {
        var m = r.macros;
        return '<li><button type="button" class="recipe-browse__item" data-ho-open="' + esc(r.id) + '">' +
          '<span class="recipe-browse__item-main">' +
            '<span class="recipe-browse__item-name">' +
              (unlocked ? '' : '<span class="recipe-browse__lock" aria-hidden="true">' + icon(PADLOCK) + '</span>') +
              esc(r.name) + flagBadge(r) +
            '</span>' +
            '<span class="recipe-browse__item-meta">' +
              '<span>' + esc(r.total) + '</span><span aria-hidden="true">&middot;</span>' +
              '<span>' + esc(r.yield) + '</span><span aria-hidden="true">&middot;</span>' +
              '<span>' + esc(r.difficulty) + '</span><span aria-hidden="true">&middot;</span>' +
              '<span>Health One ' + esc(r.hero) + '</span>' +
            '</span>' +
            '<span class="recipe-browse__item-macros">' +
              esc(m.cal) + ' cal &middot; ' + esc(m.protein) + ' protein &middot; ' + esc(m.carbs) + ' carbs &middot; ' +
              esc(m.fat) + ' fat &middot; ' + esc(m.fiber) + ' fiber' +
            '</span>' +
          '</span>' +
          '<span class="recipe-browse__item-tags">' + tagBadges(r, true) + '</span>' +
          icon(CHEVRON, 'recipe-browse__item-arrow') +
        '</button></li>';
      }).join('');
      return '<section class="recipe-browse__cat"><h3 class="recipe-browse__cat-title">' + esc(cat) + '</h3>' +
        '<ul class="recipe-browse__list">' + items + '</ul></section>';
    }).join('');

    return '<div class="recipe-browse">' +
      '<header class="recipe-browse__head">' +
        '<span class="eyebrow">The Collection</span>' +
        '<h2 id="ho-recipe-modal-title" class="recipe-browse__title">All ' + RECIPES.length + ' recipes.</h2>' +
        '<p class="recipe-browse__sub">' + (unlocked
          ? 'You&rsquo;re in. Click any recipe to view ingredients, directions, and macros.'
          : 'Browse the full list. We&rsquo;ll ask for an email the first time you open one &mdash; just once, then all ' + RECIPES.length + ' unlock.') +
        '</p>' +
        '<div class="recipe-browse__filter" role="group" aria-label="Filter recipes by tag">' + chips + '</div>' +
      '</header>' +
      '<div class="recipe-browse__body">' + body + '</div>' +
    '</div>';
  }

  function gateView(recipe, hasBrowse) {
    return '<div class="recipe-gate">' +
      '<div class="recipe-gate__preview">' +
        (hasBrowse ? backButton() : '') +
        '<p class="recipe-view__category">' + flagBadge(recipe) + ' ' + esc(recipe.sub) + '</p>' +
        '<h2 id="ho-recipe-modal-title" class="recipe-view__title">' + esc(recipe.name) + '</h2>' +
        (recipe.tags.length ? '<div class="recipe-view__tags">' + tagBadges(recipe) + '</div>' : '') +
        '<p class="recipe-view__hero-link" style="cursor:default">' +
          '<span class="recipe-view__hero-dot"></span>Made with Health One ' + esc(recipe.hero) +
        '</p>' +
        metaRow(recipe) +
        macroLine(recipe) +
      '</div>' +
      '<div class="recipe-gate__form">' +
        '<div class="recipe-gate__form-inner">' +
          '<span class="recipe-gate__lock-ico" aria-hidden="true">' + icon(PADLOCK) + '</span>' +
          '<h3 class="recipe-gate__h">One email unlocks all ' + RECIPES.length + ' recipes.</h3>' +
          '<p class="recipe-gate__sub">Ingredients, directions, macros, tips, storage notes &mdash; all of it. ' +
            'We&rsquo;ll also send you the printable PDF of the full collection. No spam. Unsubscribe anytime.</p>' +
          '<form class="recipe-gate__form-row" data-ho-gate novalidate>' +
            '<input type="email" name="email" placeholder="you@example.com" required aria-label="Email address" autocomplete="email">' +
            '<button type="submit" class="btn">Unlock recipes' + icon(ARROW_RIGHT) + '</button>' +
          '</form>' +
          '<p class="recipe-gate__error" data-ho-gate-error hidden role="alert"></p>' +
          '<p class="recipe-gate__legal">By unlocking, you agree to receive the Health One newsletter. We never share your address.</p>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  /* ---------- modal ---------- */

  var state = { recipeId: null, showBrowse: false, filter: null, attempts: 0 };
  var modal = null;
  var lastFocus = null;

  function render() {
    var recipe = state.recipeId ? BY_ID[state.recipeId] : null;
    var unlocked = isUnlocked();
    var inner;

    if (recipe && !unlocked) inner = gateView(recipe, state.showBrowse);
    else if (recipe) inner = recipeView(recipe, state.showBrowse);
    else inner = browseView(state.filter, unlocked);

    modal.querySelector('.recipe-modal__panel').innerHTML =
      '<button type="button" class="recipe-modal__close" aria-label="Close" data-ho-close></button>' + inner;
    modal.querySelector('.recipe-modal__panel').scrollTop = 0;

    var email = modal.querySelector('[data-ho-gate] input');
    if (email) email.focus();
    else modal.querySelector('.recipe-modal__close').focus();
  }

  function open(recipeId, showBrowse) {
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'recipe-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'ho-recipe-modal-title');
      modal.innerHTML = '<div class="recipe-modal__backdrop" data-ho-close></div><div class="recipe-modal__panel"></div>';
      modal.addEventListener('click', onModalClick);
      modal.addEventListener('submit', onGateSubmit);
    }
    if (!modal.parentNode) {
      lastFocus = document.activeElement;
      document.body.appendChild(modal);
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeydown);
    }
    state.recipeId = recipeId || null;
    state.showBrowse = !!showBrowse;
    state.attempts = 0;
    render();
  }

  function close() {
    if (!modal || !modal.parentNode) return;
    document.removeEventListener('keydown', onKeydown);
    document.body.style.overflow = '';
    modal.parentNode.removeChild(modal);
    state.recipeId = null;
    state.showBrowse = false;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') close();
  }

  function onModalClick(e) {
    var el;
    if ((el = e.target.closest('[data-ho-close]'))) { close(); return; }
    if ((el = e.target.closest('[data-ho-shop]'))) { close(); return; }   // let the #products anchor run
    if ((el = e.target.closest('[data-ho-browse]'))) {
      e.preventDefault();
      state.recipeId = null; state.showBrowse = true;
      render();
      return;
    }
    if ((el = e.target.closest('[data-ho-filter]'))) {
      e.preventDefault();
      var tag = el.getAttribute('data-ho-filter');
      state.filter = (tag && state.filter !== tag) ? tag : null;
      render();
      return;
    }
    if ((el = e.target.closest('[data-ho-open]'))) {
      e.preventDefault();
      state.recipeId = el.getAttribute('data-ho-open');
      state.showBrowse = true;    // reached from the browse index, so offer "back"
      state.attempts = 0;
      render();
    }
  }

  function onGateSubmit(e) {
    var form = e.target.closest('[data-ho-gate]');
    if (!form) return;
    e.preventDefault();

    var input = form.querySelector('input');
    var button = form.querySelector('button');
    var errorEl = modal.querySelector('[data-ho-gate-error]');
    var email = (input.value || '').trim();
    var buttonHtml = button.innerHTML;

    function fail(message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
      button.disabled = false;
      button.innerHTML = buttonHtml;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      fail('Please enter a valid email address.');
      input.focus();
      return;
    }

    errorEl.hidden = true;
    button.disabled = true;
    button.textContent = 'Unlocking…';
    state.attempts++;

    subscribe(email).then(function () {
      rememberUnlock(email);
      render();
    }).catch(function (err) {
      if (err && err.message === 'not-configured') {
        // Klaviyo settings not filled in yet — don't trap the visitor behind a
        // gate that can't submit. Unlock, and make the gap obvious in the console.
        console.warn('[ho-recipes] Klaviyo public key / list ID not set on the recipes section — ' +
          'the gate unlocked but no email was captured.');
        rememberUnlock(email);
        render();
        return;
      }
      console.error('[ho-recipes] subscribe failed:', err);
      if (state.attempts >= 2) {
        // Second failure: let them through rather than lose them to an outage.
        rememberUnlock(email);
        render();
        return;
      }
      fail('Something went wrong. Please try again.');
    });
  }

  /* ---------- page wiring ---------- */

  host.addEventListener('click', function (e) {
    var card = e.target.closest('[data-ho-open]');
    if (card) { e.preventDefault(); open(card.getAttribute('data-ho-open'), false); return; }
    if (e.target.closest('[data-ho-browse]')) { e.preventDefault(); open(null, true); }
  });

  // The teaser tiles are role="button" tabindex="0", so drive them from the keyboard too.
  host.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var card = e.target.closest('.recipe-card[data-ho-open]');
    if (!card) return;
    e.preventDefault();
    open(card.getAttribute('data-ho-open'), false);
  });

  /* ============================================================
     Page signup forms — the hero form and the lead-magnet card.
     They post to the same Klaviyo list as the recipe gate, so one address
     both receives the PDF and unlocks the collection, whichever form it
     came from. Markup and styling are the Claude Design originals.
     ============================================================ */

  var SIGNUP_DONE = {
    hero: 'Recipe collection is on its way to <strong>{email}</strong>. Check your inbox in a few minutes.',
    leadmagnet: 'On its way to <strong>{email}</strong>. Check your inbox in a few minutes &mdash; and your spam folder, just in case.'
  };

  /* The hero form is a bordered flex row, so the message goes after it rather
     than inside, where it would break the input/button pairing. */
  function signupMessage(form) {
    var el = form.nextElementSibling;
    if (el && el.hasAttribute && el.hasAttribute('data-ho-msg')) return el;
    el = document.createElement('p');
    el.setAttribute('data-ho-msg', '');
    el.className = 'ho-signup-msg';
    el.setAttribute('role', 'alert');
    el.hidden = true;
    form.parentNode.insertBefore(el, form.nextSibling);
    return el;
  }

  function signupSucceeded(form, email, source) {
    rememberUnlock(email);
    var msg = form.nextElementSibling;
    if (msg && msg.hasAttribute && msg.hasAttribute('data-ho-msg')) msg.parentNode.removeChild(msg);
    var done = document.createElement('div');
    done.className = 'leadmagnet__success';
    if (source === 'hero') { done.style.marginBottom = '14px'; done.style.maxWidth = '520px'; }
    done.innerHTML = (SIGNUP_DONE[source] || SIGNUP_DONE.leadmagnet).replace('{email}', esc(email));
    form.parentNode.replaceChild(done, form);
  }

  function initSignupForms() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ho-signup]'), function (form) {
      var attempts = 0;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var source = form.getAttribute('data-ho-signup');
        var input = form.querySelector('input[type="email"]');
        var button = form.querySelector('button');
        var msg = signupMessage(form);
        var email = (input.value || '').trim();
        var buttonHtml = button.innerHTML;

        function fail(text) {
          msg.textContent = text;
          msg.hidden = false;
          button.disabled = false;
          button.innerHTML = buttonHtml;
        }

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          fail('Please enter a valid email address.');
          input.focus();
          return;
        }

        msg.hidden = true;
        button.disabled = true;
        button.textContent = 'Sending…';
        attempts++;

        subscribe(email, source === 'hero' ? 'Healthy Cooking — hero form' : 'Healthy Cooking — lead magnet')
          .then(function () { signupSucceeded(form, email, source); })
          .catch(function (err) {
            if (err && err.message === 'not-configured') {
              console.warn('[ho-recipes] Klaviyo public key / list ID not set — the ' + source +
                ' form accepted the address but captured nothing.');
              signupSucceeded(form, email, source);
              return;
            }
            console.error('[ho-recipes] ' + source + ' signup failed:', err);
            // Second failure: acknowledge rather than trap them in a broken form.
            if (attempts >= 2) { signupSucceeded(form, email, source); return; }
            fail('Something went wrong. Please try again.');
          });
      });
    });
  }
  initSignupForms();

  // Deep link: /pages/cooking#recipe-<slug> or #recipes-all
  function fromHash() {
    var hash = window.location.hash;
    if (hash === '#recipes-all') open(null, true);
    else if (hash.indexOf('#recipe-') === 0 && BY_ID[hash.slice(8)]) open(hash.slice(8), false);
  }
  fromHash();
  window.addEventListener('hashchange', fromHash);
})();
